export {default as CreateAccount} from './CreateAccountContainer';



// WEBPACK FOOTER //
// ./src/components/Form/CreateAccount/index.js